import React from 'react';
import { Modal, Button } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';

interface DeleteUserModalProps {
  open: boolean;
  userName: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  open,
  userName,
  loading = false,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal open={open} onCancel={onCancel} footer={null} closable={false} width={400} centered>
      <div className="flex gap-3 items-start">
        <CloseCircleFilled
          className="text-2xl flex-shrink-0"
          style={{ color: 'var(--color-status-error)' }}
        />
        <div className="flex flex-col flex-1">
          <p className="font-semibold text-base leading-6 text-content-primary mb-2">
            Are you sure you want to delete this user?
          </p>
          <p className="text-sm leading-[22px] text-content-primary">
            <span className="font-semibold">{userName}</span> will be removed from this organization
            and lose access immediately.
          </p>
          <div className="flex justify-end gap-2 mt-3">
            <Button
              type="primary"
              onClick={onCancel}
              disabled={loading}
              className="!bg-btn-action-bg !text-btn-action-text hover:!bg-btn-action-hover !border-btn-action-bg"
            >
              Cancel
            </Button>
            <Button onClick={onConfirm} loading={loading} disabled={loading} danger>
              Delete
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUserModal;
